import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css'; // Importar theme.css primeiro
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { setupAxiosInterceptors } from './utils/axiosConfig';

setupAxiosInterceptors();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <ErrorBoundary area="página">
        <App />
    </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
